import popoverWidget from "../../popoverWidget/popoverWidget.js";

/**
 * Make a popover for an input value node.
 *
 * @param {DOMElement} triggerItem - Element that will trigger the popover on click
 * @param {Renderable} header - Header of the popover
 * @param {Renderable} content - Body of the popover
 * @param {Renderable} [extraFooterAction] - Optional extra action to add to the popover footer
 */
export default function makeInputValuePopover({
	triggerItem,
	header,
	content,
	extraFooterAction,
}) {
	return popoverWidget({
		triggerItem,
		popoverCssClass: "input-value-popover popover fade top",
		header,
		content,
		footer: (html) => {
			if (!extraFooterAction) return;

			html.div({ class: "popover-divider" });
			html.div({ class: "text-center" }, extraFooterAction);
		},
	});
}
